// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33yFn","title":"styles_title__z94Sb"};